export default function StepProgress({ step }) {
    const items = ["Business Details", "Theme Selection", "Review & Actions"];
    const progressPercent = ((step - 1) / (items.length - 1)) * 100;

    return (
        <div className="wg-step-progress-wrap">
            <div className="wg-step-progress wg-step-progress-desktop">
                {items.map((item, index) => {
                    const current = index + 1;
                    const isActive = step === current;
                    const isComplete = step > current;

                    return (
                        <div
                            key={item}
                            className={`wg-step-item ${isActive ? "active" : ""} ${isComplete ? "complete" : ""}`}
                        >
                            <div className="wg-step-top">
                                <div className="wg-step-number">{current}</div>
                                <div className="wg-step-title">{item}</div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="wg-step-progress-mobile">
                <div className="wg-step-mobile-head">
                    <strong>Step {step} of {items.length}</strong>
                    <span>{items[step - 1]}</span>
                </div>

                <div className="wg-step-mobile-bar">
                    <div
                        className="wg-step-mobile-fill"
                        style={{ width: `${progressPercent}%` }}
                    />
                </div>
            </div>
        </div>
    );
}